import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./rightviewstyles";
import { infoData } from "./infoenum";

class RightView extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      classes,
      result,
      subtest,
      subtestSubTestSettingsResults,
      translate
    } = this.props;

    return (
      <div className={classes.div_table}>
        <Table className={classes.table}>
          <TableHead>
          <TableCell></TableCell>
          <TableCell></TableCell>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={classes.tablecontent_first} >
                {translate("result_propagation_delay") + ":"}
              </TableCell>
              <TableCell className={classes.tablecontent_first}>
                <table>
                  <tr
                    style={{
                      background: "#f2f2f2"
                    }}
                  >
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "15px 35px 15px 35px"
                      }}
                    >
                      {translate("result_min")}
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "15px 35px 15px 35px"
                      }}
                    >
                      {translate("result_avg")}
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "15px 35px 15px 35px"
                      }}
                    >
                      {translate("result_max")}
                    </th>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "center"
                      }}
                    >
                      {subtestSubTestSettingsResults.rttmin.toFixed(3)}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "center"
                      }}
                    >
                      {subtestSubTestSettingsResults.rttavg.toFixed(3)}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "center"
                      }}
                    >
                      {subtestSubTestSettingsResults.rttmax.toFixed(3)}
                    </td>
                  </tr>
                </table>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tablecontent_first} >
              {translate("result_jitter")}:
              </TableCell>
              <TableCell className={classes.tablecontent_first}>
                <table>
                  <tr
                    style={{
                      background: "#f2f2f2"
                    }}
                  >
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "15px 35px 15px 35px"
                      }}
                    >
                      {translate("result_min")}
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "15px 35px 15px 35px"
                      }}
                    >
                      {translate("result_avg")}
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "15px 35px 15px 35px"
                      }}
                    >
                      {translate("result_max")}
                    </th>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "center"
                      }}
                    >
                      {
                        parseInt(subtestSubTestSettingsResults.jittermin)
                      }
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "center"
                      }}
                    >
                      {
                        parseInt(subtestSubTestSettingsResults.jitteravg)
                      }
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "center"
                      }}
                    >
                      {
                        parseInt(subtestSubTestSettingsResults.jittermax)
                      }
                    </td>
                  </tr>
                </table>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default withStyles(styles)(RightView);
